import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postThanetCouncilForms } from "../../redux/actions/thanetCouncilActions";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const DriverDeclarationForm = ({ appData, postThanetCouncilFormsFunc }) => {
  const initialData = {
    signature: `${appData.firstName} ${appData.lastName}`,
    name: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p className={"mb-2"}>
            I <b>{initialData.name}</b>, declare the following:
          </p>
          <ul className={"mb-2"}>
            <li className={"mb-1"}>
              I am not suffering from an existing medical condition which may
              affect my ability to drive
            </li>
            <li className={"mb-1"}>
              I am not taking prescribed drugs/ self-medication that may affect
              my ability to drive
            </li>
            <li className={"mb-1"}>
              I am not under the influence of alcohol or illegal drugs
              whatsoever
            </li>
            <li>I have the appropriate spectacles to drive (if required.)</li>
          </ul>
          <p>
            I understand that if I am in breach of any of the above, my
            assignment will be ended.
          </p>
          <p>
            I confirm that I will advise HRGO Recruitment with immediate effect
            if any of the above changes.
          </p>
        </div>
      ),
    },
    signature: {
      type: "text",
      title: "Signed",
      value: getVal("signature"),
      disabled: true,
    },
    name: {
      type: "text",
      title: "Print Name",
      value: getVal("name"),
      disabled: true,
    },
    date: {
      type: "text",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.thanetCouncilOnboarding &&
    appData.thanetCouncilOnboarding.driverDeclaration;

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postThanetCouncilFormsFunc("driverDeclaration", {
      ...fieldValuesPayload,
      date: moment().toISOString(),
    });
    history.push("/profile/edit/thanet-council-onboarding");
  };

  const redirectBack = () => {
    history.push("/profile/edit/thanet-council-onboarding");
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Driver Declaration"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"thanetCouncil"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

DriverDeclarationForm.propTypes = {
  appData: any,
  postThanetCouncilFormsFunc: func,
};

const mapDispatchToProps = {
  postThanetCouncilFormsFunc: postThanetCouncilForms,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(DriverDeclarationForm);
